module.exports = "<div class=\"row\">\n    <div class=\"col-md-3\">\n        <span class=\"hipster img-fluid img-rounded\"></span>\n    </div>\n    <div class=\"col-md-9\">\n        <p class=\"lead\" jhiTranslate=\"home.waitaminute\">Veuillez patienter, vous allez bientôt accéder à Cadens</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/home/home.component.html
// module id = 455
// module chunks = 0